const DEFAULT_TABLES_SORT_PROJECT_FIELD = 'name'
const DEFAULT_TABLES_SORT_USER_FIELD = 'first_name'
const DEFAULT_TABLES_SORT_COMPANY_FIELD = 'name'

export {
  DEFAULT_TABLES_SORT_PROJECT_FIELD,
  DEFAULT_TABLES_SORT_USER_FIELD,
  DEFAULT_TABLES_SORT_COMPANY_FIELD,
}
